import GuideLineParser from './guide';
import LineParser from './main';
import MiniLineParser from './mini';

export default {
  main: LineParser,
  guide: GuideLineParser,
  mini: MiniLineParser,
};
